var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100 h-100"},[_c('vue-apex-charts',{ref:("simple-bar-" + _vm.name),attrs:{"type":"bar","height":_vm.height,"options":_vm.options,"series":_vm.series}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }